import { formatNumberWithFixed } from './numbers';
import moment from 'moment-timezone';

function formatPrice(price, currency) {
  return `${formatNumberWithFixed(price, 2)} ${currency}`;
}

function formatDiscount(discountObject, currency) {
  if (discountObject.discountType === 'percent') {
    return `${discountObject.discount}%`;
  } else {
    return formatPrice(discountObject.discount, currency);
  }
}

function  displayDateWithOffset(utcDateString, utcOffset) {
  const momentDate = moment.utc(utcDateString);

  const formattedOffset = utcOffset[0] + utcOffset.substring(1, 3) + ':' + utcOffset.substring(3, 5);

  return momentDate.utcOffset(formattedOffset).format('YYYY-MM-DD HH:mm:ss');
}

export { formatPrice, formatDiscount, displayDateWithOffset };
